'use client';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { classNames } from '../../helpers/classNames';
import { BtnVariant } from '../ButtonVariant';
import styles from './style.module.scss';

interface Props {
    variant?: BtnVariant;
    className?: any;
    size?: string;
    type?: 'button' | 'submit' | 'reset';
    onClick?: (param: any) => void;
    link: string;
    icon?: IconProp;
    children: React.ReactNode;
    disabled?: boolean;
    role?: string;
    tabIndex?: number;
}

function ButtonLink(props: Props) {
    const {
        className,
        variant = 'primary',
        size,
        type,
        onClick,
        link,
        icon,
        children,
        disabled,
        role,
        tabIndex,
    } = props;

    return (
        <Link
            to={link}
            className={classNames([
                styles.btn,
                className,
                styles[variant],
                size,
                type,
            ])}
            onClick={onClick}
            aria-disabled={disabled}
            role={role}
            tabIndex={tabIndex}
        >
            {icon && <FontAwesomeIcon className={styles.icon} icon={icon} />}
            {children}
        </Link>
    );
}

export default ButtonLink;
